<template>
    <v-dialog v-model="show" width="500" persistent no-click-animation>
        <v-card>
            <v-layout align-center class="primary px-2 py-1">
                <div class="title" style="color: #fff">{{ $f.capitalize($t('confirm')) }}</div>
            </v-layout>
            <div class="pa-3" style="font-size: 15px">
                {{ message }}
            </div>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="deny">
                    {{ $f.capitalize($t('cancel')) }}
                </v-btn>
                <v-btn color="primary" @click="confirm">
                    {{ $f.capitalize($t('confirm')) }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
    name: 'Confirm',
    data () {
        return {
            show: false,
            promise: null,
            message: ''
        }
    },
    methods: {
        open (message) {
            this.message = message
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        confirm () {
            this.show = false
            this.promise.resolve(true)
        },
        deny () {
            this.show = false
            this.promise.reject(false)
        }
    }
}
</script>
